module.exports = {
      id: "black_white_color-usage",
      viewBox: "0 0 249.64 353.6",
      url: __webpack_public_path__ + "img/icons.400d09d6.svg#black_white_color-usage",
      toString: function () {
        return this.url;
      }
    }